// ─── coverPhotoUtils.js ───────────────────────────────────────────────────────
// Pure helper for the Condition Report cover-photo picker. Flattens every photo on
// the project into pickable candidates. PURE: never mutates project.areas (Excel
// indexes areas by position).

// fullUrl is what we STORE (the cover prints at ~5.6in; a 300px thumbnail looks mushy).
// thumbUrl is what we DISPLAY in the grid. Deduped by fullUrl, source order preserved.
export function collectCoverCandidates(project) {
  const out = [];
  const seen = new Set();
  ((project && project.areas) || []).forEach((area) => {
    (area.photos || []).forEach((p) => {
      const fullUrl = p.url || p.thumbnailUrl;
      if (!fullUrl || seen.has(fullUrl)) return;
      seen.add(fullUrl);
      out.push({
        fullUrl,
        thumbUrl: p.thumbnailUrl || p.url,
        areaName: area.name || '',
        substrate: p.substrate || '',
      });
    });
  });
  return out;
}
